export function InstantAccessChart() {
  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <h2 className="text-xl font-bold text-foreground mb-6">Instant Access Insights</h2>
      {/* Customize your instant access chart here */}
      <div>Chart for Instant Access</div>
    </div>
  )
}
